import React, { Component } from "react";
// import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { MdModeEdit, MdPageview /* MdDelete */ } from "react-icons/md";
import { tableFilters } from "../../_utils";
class DataTable extends Component {
  render() {
    const {
      data,
      columns,
      defaultPageSize,
      urlParams,
      loading,
      hideButtons,
      cannotEdit
    } = this.props;
    const columnsWithActions = [
      ...columns,
      {
        sortable: false,
        filterable: false,
        Cell: row => (
          <div style={{ whiteSpace: "normal" }}>
            <Link
              to={urlParams ? `${urlParams.url}/view/${row.original.id}` : "/"}
              className="btn mb-1 btn-success btn-sm"
            >
              <MdPageview /> View
            </Link>{" "}
            {cannotEdit ? (
              ""
            ) : (
              <Link
                to={
                  urlParams ? `${urlParams.url}/edit/${row.original.id}` : "/"
                }
                className="btn mb-1 btn-primary btn-sm"
              >
                <MdModeEdit /> Edit
              </Link>
            )}
            {/*  <Button color="danger" size="sm">
              <MdDelete /> Delete
            </Button> */}
          </div>
        )
      }
    ];
    return (
      <ReactTable
        loading={loading}
        data={data}
        defaultPageSize={defaultPageSize}
        columns={hideButtons ? columns : columnsWithActions}
        filterable
        defaultFilterMethod={(filter, row) =>
          tableFilters.defaultFilterMethod(filter, row)
        }
      />
    );
  }
}

export default DataTable;
